export default __webpack_public_path__ + "static/media/img-slider-siamblockchain-1.df8cc860.png";